const codeFromPath = (path: string): string => {
  const fileName = path.split("/").pop() ?? ""
  return fileName.replace(/\.[^.]+$/, "")
}

export const indexImagesByCode = (
  modules: Record<string, string>
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(modules).map(([path, url]) => [codeFromPath(path), url])
  )
